export default __webpack_public_path__ + "static/media/contact-active.058f41d0.svg";